import {
    LOAD_RESTAURANT_INSIGHT,
    LOAD_RESTAURANT_INSIGHT_DISABLED,
    ENABLE_DISABLE_RESTAURANT_INSIGHT,
    LOAD_RESTAURANT_INSIGHT_PRODUCT_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PROMOTION_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PROMOCODES_SUMMARY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_HOURLY_ORDER_FREQUENCY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH,
    LOAD_RESTAURANT_INSIGHT_ORDER_TYPE_SEARCH,
    LOAD_RESTAURANT_INSIGHT_SOURCE_TYPE_SEARCH,
    LOAD_RESTAURANT_INSIGHT_PAYMENT_TYPE_SEARCH
} from "../../../actions/types";

const INITIAL_STATE = {

    lastYearOrdersCount: 0,
    migrationEndTime: null,
    migrationStartTime: null,
    orderFrequency: 0,
    orderFrequencyPerDay: 0,
    restaurantId: null,
    status: null,
    // uniqueCustomersCount: 0,
    insightEnabled: null,
    productSummary: {},
    promotionSummary: {},
    promoCodesSummary: {},
    orderHourlyFrequency: [],
    orderDailyFrequency: [],
    orderTypeSummary: [],
    sourceTypeSummary: [],
    paymentTypeSummary: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_RESTAURANT_INSIGHT:
            return {
                ...action.payload,
                insightEnabled: true
            };
        case ENABLE_DISABLE_RESTAURANT_INSIGHT:
            return {
                ...action.payload,
                insightEnabled: true
            };
        case LOAD_RESTAURANT_INSIGHT_DISABLED:
            return {
                lastYearOrdersCount: 0,
                migrationEndTime: null,
                migrationStartTime: null,
                orderFrequency: 0,
                orderFrequencyPerDay: 0,
                restaurantId: null,
                status: null,
                // uniqueCustomersCount: 0,
                insightEnabled: false
            }
        case LOAD_RESTAURANT_INSIGHT_PRODUCT_SUMMARY_SEARCH:
            return { 
                ...state,
                productSummary: action.payload
            }
        case LOAD_RESTAURANT_INSIGHT_PROMOTION_SUMMARY_SEARCH:
            return {
                ...state,
                promotionSummary: action.payload
            }
        case LOAD_RESTAURANT_INSIGHT_PROMOCODES_SUMMARY_SEARCH:
            return {
                ...state,
                promoCodesSummary: action.payload
            }
        case LOAD_RESTAURANT_INSIGHT_HOURLY_ORDER_FREQUENCY_SEARCH:
            return {
                ...state,
                orderHourlyFrequency: [...action.payload]
            }
        case LOAD_RESTAURANT_INSIGHT_DAILY_ORDER_FREQUENCY_SEARCH:
            return {
                ...state,
                orderDailyFrequency: [...action.payload]
            }
        case LOAD_RESTAURANT_INSIGHT_ORDER_TYPE_SEARCH: {
            return {
                ...state,
                orderTypeSummary: [...action.payload]
            }
        }
        case LOAD_RESTAURANT_INSIGHT_SOURCE_TYPE_SEARCH: {
            return {
                ...state,
                sourceTypeSummary: [...action.payload]
            }
        }
        case LOAD_RESTAURANT_INSIGHT_PAYMENT_TYPE_SEARCH: {
            return {
                ...state,
                paymentTypeSummary: [...action.payload]
            }
        }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/restaurants/restaurantInsight/RestaurantInsightReducer.js